import {
    Box, Button, Flex, Link, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay,
    Table,
    Tbody,
    Text,
    Th,
    Thead,
    Tr,
    useColorModeValue, useDisclosure,
} from "@chakra-ui/react";
import React, {useEffect, useState} from "react";
import axios from 'axios'
import {useAuthHeader} from  'react-auth-kit'
import {
    getCoreRowModel,
    getFilteredRowModel,
    getSortedRowModel,
    useReactTable,
} from '@tanstack/react-table'
import { useInfiniteQuery, } from '@tanstack/react-query'
import AdminNavbar from "../../Navbars/AdminNavbar";
import TableLimitsRow from "../../TableLimitsRow";
import {Link as ReactRouterLink} from 'react-router-dom'
import { Link as ChakraLink } from '@chakra-ui/react'


const LimitsTable = ({ title, columns }) => {

    const textColor = useColorModeValue("gray.700", "white");
    const tableContainerRef = React.useRef(null)
    const [sorting, setSorting] = React.useState([])
    const token = useAuthHeader();
    const [globalFilter, setGlobalFilter] = React.useState('')
    const { isOpen, onOpen, onClose } = useDisclosure()
    const [action, setAction] = useState(false)
    const [approve, setApprove] = useState(false)
    const [limitId, setLimitId] = useState('')
    const [resp, setResp] = useState(null)

    const refresh = () => window.location.reload(true)

    const approveAction = () => {
        setApprove(true)
        // onClose()
        // refresh()
    }

    const approveAction2 = () => {
        onClose()
        refresh()
    }


    const { data, isLoading } =
        useInfiniteQuery(
            ["limits", sorting],
            async () => {
                const res = await axios.get(`/api/v1/limits/templates`, { headers: {Authorization: token() } })
                const fetchedData = await res.data
                return fetchedData
            },
            {
                keepPreviousData: true,
                refetchOnWindowFocus: false,
            }
        )

    const flatData = React.useMemo(
        () => data?.pages?.flatMap(page => page) ?? [],
        [data]
    )

    const table = useReactTable({
        data: flatData,
        columns,
        state: {
            sorting, globalFilter
        },
        onSortingChange: setSorting,
        onGlobalFilterChange: setGlobalFilter,
        getFilteredRowModel: getFilteredRowModel(),
        getCoreRowModel: getCoreRowModel(),
        getSortedRowModel: getSortedRowModel(),
        enableGlobalFilter: true
    })

    const { rows } = table.getRowModel()

    useEffect(() => {
        if (action){
            setAction(false)
            onOpen()
        }
    },[action])


    if (isLoading) {
        return <>Loading...</>
    }

    return (
        <>
            <Box>
                <AdminNavbar
                    logoText={'SURELLE DASHBOARD'}
                    initialValue={globalFilter ?? ''}
                    onChange={e => setGlobalFilter(e)}
                    debounce={500}
                />
            </Box>
            <Box p='6px 0px 22px 0px'>
                    <Text fontSize='xl' color={textColor} fontWeight='bold'>
                        {title}
                    </Text>
            </Box>
            <Box p='6px 0px 22px 0px'>
                <ChakraLink color='teal.500' as={ReactRouterLink} to='/admin_area/limits/create'>
                    Создать лимит
                </ChakraLink>
            </Box>

            <Box overflowX="auto"
                 maxH="800px"
                 ref={tableContainerRef}
            >
                <Table variant='simple' color={textColor}>
                    <Thead>
                        {table.getHeaderGroups().map(headerGroup => (
                            <Tr key={headerGroup.id}  my='.8rem' pl='0px' color='gray.400'>
                                {headerGroup.headers.map((header, idx) => {
                                    return (
                                        <Th
                                            key={header.id}
                                            color='gray.400'
                                            ps={idx === 0 ? "0px" : null}
                                        >
                                            <div
                                                className={
                                                    header.column.getCanSort()
                                                        ? 'cursor-pointer select-none'
                                                        : undefined
                                                }
                                                onClick={header.column.getToggleSortingHandler()}
                                            >
                                                {header.column.columnDef.header}
                                                {{
                                                    asc: ' 🔼',
                                                    desc: ' 🔽',
                                                }[header.column.getIsSorted()] ?? null}
                                            </div>
                                        </Th>
                                    )
                                })}
                            </Tr>
                        ))}
                    </Thead>
                    <Tbody>
                        {rows.map(row => {
                            return (
                                <TableLimitsRow
                                    key={row.id}
                                    row={row}
                                    setActive={setAction}
                                    approveDel={approve}
                                    LimitId={setLimitId}
                                    id={limitId}
                                    respon={setResp}
                                />
                            )
                        })}
                    </Tbody>
                </Table>
                <Modal isOpen={isOpen} onClose={onClose}>
                    <ModalOverlay />
                    <ModalContent>
                        <ModalHeader>Информация</ModalHeader>
                        <ModalCloseButton />
                        <ModalBody>
                            {limitId
                                ? 'Хотите удалить лимит ' + limitId + '?'
                                : ''
                            }
                            {resp
                                ? 'Лимит удален.'
                                : ''
                            }
                        </ModalBody>
                        <ModalFooter>
                            {limitId
                                ? <Button variant='ghost' onClick={approveAction}>Да</Button>
                                : <Button variant='ghost' onClick={approveAction2}>Закрыть</Button>
                            }
                            {resp
                                ? ''
                                : <Button colorScheme='blue' onClick={onClose}>Нет</Button>
                            }

                        </ModalFooter>
                    </ModalContent>
                </Modal>
            </Box>
        </>
    );
};

export default LimitsTable;

